import { Film } from 'src/types/film';

export const DEFAULT_FILM: Film = {
    kinopoiskId: -1,
    nameRu: '',
    ratingKinopoisk: -1,
    year: -1,
    genres: [],
    type: '',
    posterUrl: '',
    posterUrlPreview: '',
};
